var HelperTools = {
    SanitizeMenuResponse: SanitizeMenuResponse
}

function SanitizeMenuResponse(res){
    console.log(res);
    let sanitizedRes = [
        {
            category:"APPETIZER",
            items:[]
        },
        {
            category:"SASHIMI",
            items:[]
        },
        {
            category:"SUSHI",
            items:[]
        },
        {
            category:"SUSHI ROLL",
            items:[]
        },
        {
            category:"A LA-CARTE",
            items:[]
        },
        {
            category:"DONBURI RICE BOWL",
            items:[]
        },
        {
            category:"COMBO",
            items:[]
        },
        {
            category:"NOODLE",
            items:[]
        },{
            category:"SUSHI PARTY TRAYS",
            items:[]
        },
        {
            category:"LUNCH SPECIAL",
            items:[]
        },
        {
            category:"OTHERS",
            items:[]
        }
    ];
    for (var i = 0; i<res.length; i++){
        let menuItem = res[i];
        let singleItem = {name:menuItem.ACF.menu_item, price:menuItem.ACF.price}
        if(menuItem.ACF.category.toUpperCase() == "APPETIZER"){
            sanitizedRes[0].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "SASHIMI"){
            sanitizedRes[1].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "SUSHI"){
            sanitizedRes[2].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "SUSHI ROLL"){
            sanitizedRes[3].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "A LA-CARTE"){
            sanitizedRes[4].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "DONBURI RICE BOWL"){
            sanitizedRes[5].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "COMBO"){
            sanitizedRes[6].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "NOODLE"){
            sanitizedRes[7].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "SUSHI PARTY TRAYS"){
            sanitizedRes[8].items.push(singleItem);
        }else if(menuItem.ACF.category.toUpperCase() == "LUNCH SPECIAL"){
            sanitizedRes[9].items.push(singleItem);
        }
        else {
            sanitizedRes[10].items.push(singleItem);
        }
    }
    return sanitizedRes;
}

export default HelperTools


